<template lang="pug">
    .input_container
        vm-input(icon="search-outline" v-model="model" @keypress.enter="enter")
        vm-icon.icon_delete(v-if="model.length" icon="close-outline" @on-icon-click="clickDelete")
</template>
<script>
export default {
  name: 'InputDashboard',
  data () {
    return {
      model: ''
    }
  },
  methods: {
    enter () {
      this.$emit('enter', this.model)
    },
    clickDelete () {
      this.model = ''
      this.$emit('click-delete', this.model)
    }
  }
}
</script>

<style lang="scss">

.input_container {
    position: relative;
    width: 100%;
    flex: 1;

    .vm-input--input {
        width: 100%;
        flex: 1;
        padding-left: 2.2rem;

        &:focus {
            padding-left: 2.3rem;
            + .vm-input--icon {
                border-right: none;
        }
    }

    }
    .vm-input--icon{
        position: absolute;
        cursor: pointer;
        top: 0.7rem;
        left: 0.7rem;
        opacity: 0.5;

        transform: scale(1.3);

        border-right: 1px solid rgba(0,0,0,0.7);
    }

    .icon_delete {
        position: absolute;
        color: red;
        cursor: pointer;
        bottom: 0.7rem;
        right: 0.5rem;
        opacity: 0.5;
        transform: scale(1.3);
    }

    .icon_delete:hover {
        opacity: 1;
    }

}

</style>
